import { useProcess, useSelect } from '~/store'
import type { DocumentViewerMessage } from '@st/document-viewer-kit'
import { JsonMap, JSONValue } from '@st/util/json-value'
import { useCallback } from 'react'
import type { STFolderMessage } from './st-folder-module'
import { selFolderId, selEvalFolderStateExpr, selReadInput } from './st-folder-selectors'

export function useSendViewerMessage(send: (message: STFolderMessage) => void) {
  return useCallback(
    (message: DocumentViewerMessage) =>
      send({ type: 'viewer', message: { type: 'viewer', message } }),
    [send]
  )
}

export function useRead(key: string): JSONValue {
  return useSelect('stFolder', selReadInput, key)
}

export function useInputsWrite() {
  const process = useProcess('stFolder')
  const folderId = useSelect('stFolder', selFolderId)
  return useCallback(
    (inputs: JsonMap) => {
      if (!folderId) return
      process.send({
        type: 'requestEnqueued',
        request: {
          type: 'folders/setFolderInputs',
          folderId,
          inputs: inputs
        }
      })
    },
    [process, folderId]
  )
}

/**
 * Hook to evaluate a custom expression for the current folder/client organizer/questionnaire.
 *
 * For example:
 * ```
 * const value = useEvalFolderExpr('basic_info.number_of_dependents>0')
 * ```
 */
export function useEvalFolderExpr(expr: string | undefined) {
  return useSelect('stFolder', (s) => selEvalFolderStateExpr(s, expr))
}
